import React from "react";

import { Chip, ChipProps } from "@mui/material";

export const Tag: React.FC<ChipProps> = ({ ...props }) => {
  return <Chip size="medium" {...props} />;
};
